import PropertyPanel from './PropertyPanel';

import { adproductsUtils } from '@zg-rentals/rental-revenue-components';
import { Adproduct } from './Adproduct';
import UserAddress from './UserAddress';

export type PhotoUrlsProps = {
  medium: string;
  thumb: string;
};

const PhotoUrls = ({ medium = '', thumb = '' }: Partial<PhotoUrlsProps> = {}): PhotoUrlsProps => ({
  medium: String(medium),
  thumb: String(thumb),
});

const Status = ({
  message = '',
  code = '',
  text = '',
  tagAppearance = '',
  status = '',
}: {
  message?: string;
  code?: string;
  text?: string;
  tagAppearance?: string;
  status?: string;
}) => ({
  message: String(message),
  code: String(code),
  text: String(text),
  tagAppearance: String(tagAppearance),
  status: String(status),
});

const shouldHideBoost = (hasBoost: boolean, productTypes = []) =>
  !hasBoost ||
  productTypes.length === 0 ||
  adproductsUtils.hasPackage(productTypes) ||
  adproductsUtils.hasReit(productTypes) ||
  adproductsUtils.hasRocketship(productTypes);

const Property = ({
  activityMessage = '',
  adproduct = {},
  additionalListingSources = [],
  address = {
    street: '',
    city: '',
    state: '',
    zip: '',
    unit: '',
  },
  // NOTE: for `/list` api `dateLastActivatedTimestamp` is a `Number`
  dateLastActivatedTimestamp = 0,
  feedId = '',
  feedName = '',
  isActive = false,
  isFeed = '',
  isMultifamily = false,
  listingAlias = '',
  name = '',
  panels = [],
  photoUrls = {},
  status = {},
  syndicationOverviewStatus = '',
  syndicationOverviewDisplayStatus = '',
  syndicationOverviewDisplayExplanation = '',
  tourCount = 0,
  userManagementCompanyId = undefined,
} = {}) => {
  const formattedAdproduct = Adproduct(adproduct);
  return {
    activityMessage: String(activityMessage),
    additionalListingSources,
    adproduct: formattedAdproduct,
    address: UserAddress(address),
    dateLastActivatedTimestamp: Number(dateLastActivatedTimestamp),
    feedId: String(feedId),
    feedName: String(feedName),
    hideBoost: Boolean(shouldHideBoost(formattedAdproduct.hasBoost, formattedAdproduct.productTypes)),
    isActive: Boolean(isActive),
    isFeed: Boolean(isFeed),
    isMultifamily: Boolean(isMultifamily),
    listingAlias: String(listingAlias),
    name: String(name),
    panels: panels.map((item) => PropertyPanel(item)),
    photoUrls: PhotoUrls(photoUrls),
    status: Status(status),
    syndicationOverviewStatus: String(syndicationOverviewStatus),
    syndicationOverviewDisplayStatus: String(syndicationOverviewDisplayStatus),
    syndicationOverviewDisplayExplanation: String(syndicationOverviewDisplayExplanation),
    tourCount: Number(tourCount),
    userManagementCompanyId,
  };
};

export default Property;

export type PropertyProps = ReturnType<typeof Property>;
